/**
 * Utility functions for member-related operations
 */

/**
 * Check if a member is blocked.
 * Handles boolean, stringified boolean, numbers, or nested member object.
 *
 * @param {object} member
 * @returns {boolean}
 */
export const isMemberBlocked = (member) => {
  if (!member) return false;
  return (
    member.is_blocked === true ||
    member.is_blocked === 'true' ||
    member.is_blocked === 1 ||
    member.isBlocked === true ||
    member.isBlocked === 'true' ||
    member.isBlocked === 1 ||
    member.rawMember?.is_blocked === true ||
    member.rawMember?.is_blocked === 'true' ||
    member.rawMember?.is_blocked === 1 ||
    member.rawMember?.isBlocked === true ||
    member.rawMember?.isBlocked === 'true' ||
    member.member?.is_blocked === true ||
    member.member?.is_blocked === 'true' ||
    member.member?.is_blocked === 1 ||
    member.member?.isBlocked === true
  );
};

export default isMemberBlocked;
